type DiscordSdkModule = typeof import('@discord/embedded-app-sdk');

/**
 * Isolated so the SDK stays a dynamic import: the web build must never pull it
 * into the entry chunk, and tests can assert it was never requested.
 */
export function loadDiscordSdk(): Promise<DiscordSdkModule> {
  return import('@discord/embedded-app-sdk');
}
